export const formatUTCDateToReadable = utcDateString => {
  const date = utcDateString
    ? new Date(new Date(utcDateString).getTime() + new Date().getTimezoneOffset() * -60000)
    : new Date();

  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const dayName = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  let hour = date.getHours();
  const minute = date.getMinutes();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12; // the hour '0' should be '12'
  const minuteStr = minute < 10 ? `0${minute}` : minute;

  return `${dayName} ${day} ${month} ${year}, ${hour}:${minuteStr}${ampm}`;
};
